import { Section } from "web/hooks/useMedicalRecordStore";

interface MedicalTemplateContent {
    name: string;
    sections: Section[];
    do_add_asterisk: boolean;
    vaccines_instructions: boolean;
    version?: number;
    language?: string;
    custom_instructions?: string;
    type?: string;
}

export class MedicalTemplate {
    id?: string;
    content: MedicalTemplateContent; 
    createdAt: Date;
    isCurrent: boolean;
    organizationId: string;

    constructor(data: Partial<MedicalTemplate> = {}) {
        this.id = data.id;
        this.content = data.content || {
            name: '',
            sections: [],
            do_add_asterisk: false,
            vaccines_instructions: false,
            version: 1, 
            language: 'English (United States)',
            type: 'SOAP',
        };
        this.createdAt = data.createdAt ? new Date(data.createdAt) : new Date();
        this.isCurrent = data.isCurrent || false;
        this.organizationId = data.organizationId || '';
    }

    // Function to convert content to a JSON string
    toDTO() {
        return {
            content: JSON.stringify(this.content),  // Convert content to a string
            isCurrent: this.isCurrent,
        };
    }
}
